export enum UserType {
  None = 0,
  Conadis = 1,
  Organization = 2,
}
